// extracted by mini-css-extract-plugin
module.exports = {"root":"rasterizing-message-module__root___313U0"};